import { DASHBOARD } from "./action";

const INITIAL_STATE = {
  commodityData: [],
  fetchingComplete: false
};

export const selectedCommodityReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DASHBOARD.getCommodityData.start:
      return {
        ...state,
        fetchingComplete: false
      };
    case DASHBOARD.getCommodityData.success:
      return {
        ...state,
        fetchingComplete: true,
        commodityData: action.data.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/inventorystatus/reducer.js